import React from 'react';
import { FieldArray } from 'redux-form';
import COGSFieldArray from './COGSFieldArray';
import './COGS.css';

class COGS extends React.Component {
  render() {
    const { classButton, disabled, itemDetail } = this.props;
    const defaultValue = { price: undefined, sku: undefined };
    return (
      <FieldArray
        name="item_variants"
        component={COGSFieldArray}
        defaultValue={defaultValue}
        disabled={disabled}
        classButton={classButton}
        itemDetail={itemDetail}
      />
    );
  }
}

export default COGS;
